/**
 * Default homologacion object matching frontend structure
 * This is a copy of the shared config to avoid CRA build issues
 */
import type { ReferenceDim } from '../types';

export const defaultReferenceDim: ReferenceDim = {
  delantera: [
    { key: 'Distancia superior del Gálibo (GD2) ', code: 'GD2', value: null, check: null, min: 50, max: 4000, NA: null},
  ],
  trasera: [
    { key: 'Altura mínima de la luz inferior Freno (AT7)', code: 'FAT7', value: null, check: null, min: 200, max: 2000, NA: null },
    { key: 'Altura mínima de la luz superior de Freno (AT9)', code: 'FAT9', value: null, check: null, min: 100, max: 2500, NA: null},
    { key: 'Altura mínima de la luz inferior de Antiniebla (AN2)', code: 'AN2', value: null, check: null, min: 250, max: 1500, NA: null },
    { key: 'Altura mínima del catadióptrico trasero inferior (CT4)', code: 'CT4', value: null, check: null, min: 250, max: 1500, NA: null },
    { key: 'Altura mínima de la tercera luz de freno (3LF)', code: '3LF', value: null, check: null, min: 850, max: 4500, NA: null },
    { key: 'Altura mínima de la banda reflectante horizontal (RT5)', code: 'RT5', value: null, check: null, min: 50, max: 2500, NA: null },
    { key: 'Altura superior de la banda reflectante horizontal francesa (BRT1)', code: 'BRT1', value: null, check: null, min: 200, max: 3000, NA: null },
    { key: 'Altura mínima de las luces de matrícula (LMABI)', code: 'LMABI', value: null, check: null, min: 200, max: 4500, NA: null },
    { key: 'Altura superior del adhesivo de puntos ciegos trasero (PC4)', code: 'PC4', value: null, check: null, min: 100, max: 2000, NA: null},
  ],
  derecha: [
    { key: 'Altura mínima del carril horizontal inferior Paraciclista (PLD6)', code: 'PLD6', value: null, check: null, min: 50, max: 900, NA: null },
  ],
  izquierda: [
    { key: 'Altura mínima del carril horizontal inferior Paraciclista (PLI6)', code: 'PLI6', value: null, check: null, min: 50, max: 900, NA: null }
  ],
  both:[
    { key: 'Distancia del eje delantero al incio de la carrocería (E)', code: 'E', value: null, check: null, min: 100, max: 2000, NA: null },
  ],
} as any;
